module.exports = __webpack_public_path__ + "img/10.png.c582d12f.webp";